// extracted by mini-css-extract-plugin
export default {"main":"proSliderBlock_main__m-Xkg","main_svgDiv":"proSliderBlock_main_svgDiv__hs5lG"};